import Vue from 'vue'
import Router from 'vue-router'
import { auth } from './firebase'
import store from './store'
import Register from '@/views/dashboard/Register'
import RegisterStudent from '@/views/dashboard/pages/auth/RegisterStudent'
import Index from '@/views/dashboard/Index'
import Statistics from '@/views/dashboard/pages/admin/Statistics'
import ManagementUser from '@/views/dashboard/pages/admin/ManagementUser'
import Account from '@/views/dashboard/pages/auth/Account'
import Home from '@/views/dashboard/Home'
import UserProfile from '@/views/dashboard/pages/UserProfile'
import About from '@/views/dashboard/pages/home/About'
import Rescue from '@/views/dashboard/pages/home/Rescue'
import Contact from '@/views/dashboard/pages/home/Contact'

import Students from '@/views/dashboard/pages/panel/Students'
import DemoReport from '@/views/dashboard/pages/panel/DemoReport'

import Store from '@/views/dashboard/pages/shop/Store'
import Orders from '@/views/dashboard/pages/shop/Orders'
import Products from '@/views/dashboard/pages/shop/Products'
import PurchaseApproved from '@/views/dashboard/pages/shop/PurchaseApproved'
import PurchaseRejected from '@/views/dashboard/pages/shop/PurchaseRejected'

import Scripts from '@/views/dashboard/pages/panel/Scripts'
import Student from '@/views/dashboard/pages/panel/Student'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/registerStudent',
      component: Register,
      children: [
        // Register
        {
          path: '/registerStudent',
          name: 'RegisterStudent',
          component: RegisterStudent,
          meta: {
            requiresAuth: false,
          },
        },
      ],
    },
    {
      path: '/',
      component: Index,
      children: [
        // Admin
        {
          name: 'Administrador - Estadísticas',
          path: '/admin/statistics',
          component: Statistics,
          meta: {
            requiresAuth: false,
          },
        },
        {
          name: 'Administrador - Gestión Usuarios',
          path: '/admin/management',
          component: ManagementUser,
          meta: {
            requiresAuth: false,
          },
        },
        {
          name: 'Perfil admin',
          path: '/admin/account',
          component: Account,
          meta: {
            requiresAuth: false,
          },
        },
        // Pages
        {
          name: 'User Profile',
          path: '/pages/user',
          component: UserProfile,
        },
        {
          name: 'About',
          path: '/pages/about',
          component: About,
        },
        {
          name: 'Rescue',
          path: '/pages/rescue',
          component: Rescue,
        },
        // {
        //   name: 'Terminos y Condiciones',
        //   path: '/pages/terms',
        //   component: Terms,
        // },
        // {
        //   name: 'Politics',
        //   path: '/pages/politics',
        //   component: Politics,
        // },
        {
          name: 'Contact',
          path: '/pages/contact',
          component: Contact,
        },
        {
          name: 'Estudiantes',
          path: '/panel/students',
          component: Students,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Demo - Reporte: Episodio 1',
          path: '/panel/demoreport',
          component: DemoReport,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Catálogo',
          path: 'panel/store',
          component: Store,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Órdenes',
          path: 'panel/orders',
          component: Orders,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Mis Productos',
          path: 'panel/products',
          component: Products,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Transacción Autorizada',
          path: 'panel/store/purchase-approved',
          component: PurchaseApproved,
          meta: {
            requiresAuth: false,
          },
        },
        {
          name: 'Transacción Rechazada',
          path: 'panel/store/purchase-rejected',
          component: PurchaseRejected,
          meta: {
            requiresAuth: false,
          },
        },
        {
          name: 'Guiones',
          path: 'panel/scripts',
          component: Scripts,
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Perfil',
          path: 'panel/account',
          component: Account,
          meta: {
            requiresAuth: true,
          },
        },
        {
          //name: 'Episodios Estudiantes',
          name: 'Información de Episodio',
          path: 'panel/student/:id',
          component: Student,
          meta: {
            requiresAuth: true,
          },
        },
        // {
        //   name: 'Home',
        //   path: '*',
        //   component: Home,
        // },
        {
          path: '/',
          redirect: {
            name: 'Home'
          }
        },
        
        // Dashboard
        {
          name: 'Home',
          path: '/home',
          component: Home,
        },
      ],
    },
  ],
})

auth.onAuthStateChanged(user => {
  if (user) {
    if (user.emailVerified && router.currentRoute.name !== 'RegisterStudent') {
      store.dispatch('GET_USER', user)
    }
  } else {
    store.commit('SET_USER', null)
    router.currentRoute.name !== 'RegisterStudent' && router.push({ name: 'Home' }).catch(() => { })
  }
})

router.beforeEach((to, from, next) => {
  
    let FromRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
    let ToRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
    let isAuthenticated = auth.currentUser !== null

    if(isAuthenticated)
    {
      next()
    }
    else
    {
      if(FromRequiresAuth && ToRequiresAuth)
        next({ name: 'Home'})
      else
        next()
    }
    
    
    /*
    if (ToRequiresAuth === true) {

      console.log("router (with auth): ", from.path, to.path, auth.currentUser);
      console.trace();

      if (auth.currentUser === null) {
        next({
          name: 'Home',
        }) 
      } 
      else 
      {
        // if (from.path === '/panel/store/purchase-approved' 
        //  || from.path === '/panel/store/purchase-rejected') {
        //   console.log("transaccion resultado: ", from.path, to.path, auth.currentUser);
        //   return;
        // }

        next()
      }
    } 
    else {

      console.log("router (without auth):", from.path, to.path, auth.currentUser);
      console.trace();

      if (to.path === '/panel/store/purchase-approved' || to.path === '/panel/store/purchase-rejected') {
        console.log("transaccion resultado: ", to.path, auth.currentUser);
        next()
        return;
      }

      if (auth.currentUser === null)
        return;

      next()
    }
    */
  //}
})

export default router
